import ENDPOINT from 'constants/endPoint';
import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

export default {
  async getSettingCoin() {
    const path = ENDPOINT.SETTING_COIN;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async updateSettingCoin(payload) {
    const path = ENDPOINT.SETTING_COIN;

    const response = await axiosClient.put(path, payload);

    return response.data;
  },

  async getHistoryCoin(payload) {
    const params = getParamsFormObject(payload);
    const path = `${ENDPOINT.COIN_HISTORIES}${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },
};
